<script>
import options from './ProductDetailTablist.options'
export default options
</script>

<template>
    <article>
        <div role="tablist" aria-label="Entertainment" class="nlx-product-detail-tablist__tab-buttons">
            <button v-for="(tab, index) in tabListData"
                :key="index"
                type="button"
                role="tab"
                :aria-selected="tab.IsSelected"
                :id="`${tab.tabButtonTitle}-tab`"
                @click="selectTab(index)"
                class="nlx-product-detail-tablist__tab-button"
                :class="tab.isSelected ? 'nlx-underline' : ''"
				>
                {{ tab.tabButtonTitle }}
            </button>
        </div>

        <div v-for="(tab, index) in tabListData" :key="index">
            <section
                class="nlx-product-detail-tablist__tab-container"
                tabindex="0"
                role="tabpanel"
                :id="`${tab.tabButtonTitle}-tab`"
                :aria-labelledby="tab.tabButtonTitle"
                v-if="tab.isSelected"
                v-html="tab.tabContentData"
            ></section>
        </div>
    </article>
</template>
